import { render, staticRenderFns } from "./receiveDividends.vue?vue&type=template&id=43b8f8e9&scoped=true&"
import script from "./receiveDividends.vue?vue&type=script&lang=js&"
export * from "./receiveDividends.vue?vue&type=script&lang=js&"
import style0 from "./receiveDividends.vue?vue&type=style&index=0&id=43b8f8e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b8f8e9",
  null
  
)

export default component.exports